import { Button, DialogContent, DialogTitle } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { RtsScannedDataResponse } from "../../app/models/requestModels/rtsRequest";
import styles from "./RtsScanModule.styles";

interface ResponseDialogProps {
  open: boolean;
  onClose: any;
  successResponses: RtsScannedDataResponse[] | undefined;
  failedResponses: RtsScannedDataResponse[] | undefined;
}

const ResponseDialog: React.FC<ResponseDialogProps> = ({
  open,
  onClose,
  successResponses,
  failedResponses,
}) => {
  return (
    <>
      <Dialog open={open}>
        {successResponses && (
          <>
            <DialogTitle>Successful Insertions</DialogTitle>
            <DialogContent>
              <ol>
                {successResponses.map((item) => (
                  <li key={item.id}>
                    {" "}
                    {item.imageUrl && (
                      <img width="30px" src={item.imageUrl} alt="Thumbnail" />
                    )}
                    {item.barcode !== undefined ? item.barcode : ""}
                  </li>
                ))}
              </ol>
            </DialogContent>
          </>
        )}
        {failedResponses && (
          <>
            <DialogTitle>Failed Insertions</DialogTitle>
            <DialogContent>
              <ol>
                {failedResponses.map((item, index) => (
                  <li key={index}>
                    {item.imageUrl && (
                      <img width="30px" src={item.imageUrl} alt="Thumbnail" />
                    )}
                    {item.barcode !== undefined ? item.barcode : ""}
                    {item.reason ? ", " + item.reason : ""}
                  </li>
                ))}
              </ol>
            </DialogContent>
          </>
        )}

        <div style={styles.closeButton}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default ResponseDialog;
